import { Routes, Route, Navigate } from "react-router-dom";

import CustomerMapSection from "./sections/customerMapSection";

function MapApp() {
  const data = JSON.parse(localStorage.getItem("userData") as string);

  return (
    <Routes>
      {(data?.settings?.posMap || (data?.claims?.includes('admin') || data?.claims?.includes('pos:map:view'))) ? (
        <>
          <Route path="/" element={<CustomerMapSection />} />
        </>
      ) :
        <Route path="*" element={<Navigate to="/page404" replace />} />
      }
    </Routes>
  );
}

export default MapApp;